module.exports = __webpack_public_path__ + "img/syxpay_logo_about.3c8819fa.png";